// import React from 'react'
import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
// import { Link } from 'gatsby'

export const Wrapper = styled.div`
  .cookies-banner {
    position: fixed;
    bottom: ${calculateResponsiveSize(36)};
    right: ${calculateResponsiveSize(42)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${calculateResponsiveSize(20)};
    padding: ${calculateResponsiveSize(18)} ${calculateResponsiveSize(24)};
    font-size: ${calculateResponsiveSize(12)};
    color: #7C7D7F;
    letter-spacing: ${calculateResponsiveSize(0.12)};
    line-height: 1.25;
    border: 1px solid #7C7D7F;
    background: #ffffff;
    opacity: 0;
    visibility: hidden;
    transform: translateY(150%);
    transition: opacity 1s, transform 1s;
    z-index: 10;
  }
  &.show {
    .cookies-banner {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
  .cookies-banner-accept-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: ${calculateResponsiveSize(38)};
    padding: 0 ${calculateResponsiveSize(30)};
    text-decoration: none !important;
    font-size: ${calculateResponsiveSize(12)};
    color: #7C7D7F;
    letter-spacing: ${calculateResponsiveSize(0.12)};
    text-transform: uppercase;
    border: 1px solid #7C7D7F;
    background: #ffffff;
    transition: color 0.25s, background 0.25s;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background: #7C7D7F;
    }
  }
  ${mediaMax('mobile')} {
    .cookies-banner {
      bottom: ${calculateMobileResponsiveSize(12)};
      left: ${calculateMobileResponsiveSize(12)};
      right: ${calculateMobileResponsiveSize(12)};
      padding: ${calculateMobileResponsiveSize(12)} ${calculateMobileResponsiveSize(50)} ${calculateMobileResponsiveSize(12)} ${calculateMobileResponsiveSize(24)};
      font-size: ${calculateMobileResponsiveSize(12)};
      letter-spacing: ${calculateMobileResponsiveSize(0.12)};
    }
    .cookies-banner-accept-btn {
      height: ${calculateMobileResponsiveSize(30)};
      padding: 0 ${calculateMobileResponsiveSize(18)};
      font-size: ${calculateMobileResponsiveSize(12)};
      letter-spacing: ${calculateMobileResponsiveSize(0.12)};
    }
  }
`

export const Content = styled.div``

// export const LinkItem = styled((props) => <Link {...props} />)`
export const LinkItem = styled.a`
  text-decoration: none;
  color: #7C7D7F;
  &:hover {
    text-decoration: underline;
  }
`
